export const ORDER = {
    GET_ORDER: 'order/GET_ORDER', 
    GET_ORDER_DETAIL: 'order/SELECT_ORDER', 
    SELECT_ORDER: 'order/SELECT_ORDER', 
    CANCEL_ORDER: 'order/CANCEL_ORDER',
    CLEAR_ORDER_INFO_MESS: 'order/CLEAR_ORDER_INFO_MESS'

};